import React, {useState, useRef} from "react";
import styled from "@emotion/styled";
import { NavHashLink as NavLink } from "react-router-hash-link";
import left from "../../images/story/left.png";
import right from "../../images/story/right.png";

const BarContainer = styled.div`
  width: 100%;
  background-color: #30251D;
`;

const Box = styled.div`
  width: 80%;
  max-width: 1200px;
  margin: auto;
  text-align: center;
  padding: 0px 20px;
  position: relative;
  @media screen and (max-width: 1024px) {
    &::before {
      content: '';
      width: 70px;
      height: 100%;
      /* background: linear-gradient(to right, rgba(48,37,29,1) 0%,rgba(48,37,29,0.8) 100%); */
      background-image: url(${left});
      background-size: 100% auto;
      position: absolute;
      top: 0;
      left: 0px;
      opacity: ${props => props.opacityState.l ? 1 : 0};
      transition: all .2s;
    }
    &::after {
      content: '';
      width: 70px;
      height: 100%;
      /* background: linear-gradient(to left, rgba(48,37,29,1) 0% ,rgba(48,37,29,0.8) 100%); */
      background-image: url(${right});
      background-size: 100% auto;
      position: absolute;
      top: 0;
      right: 0px;
      opacity: ${props => props.opacityState.r ? 1 : 0};
      transition: all .2s;
    }
  }
  ul {
    padding: 20px;
  }
  li {
    position: relative;
    display: inline-block;
    padding: 0px 20px;
    /* border-left: 1px solid #FFFFFF; */
    &:not(:last-child) {
      &::after {
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #FFFFFF;
        position: absolute;
        top: 50%;
        right: 0%;
        transform: translateY(-50%);
      }
    }
    /* &:last-child {
      border-right: 1px solid #FFFFFF;
    } */
    a {
      font-weight: 500;
      font-size: 28px;
      text-align: center;
      color: #FFFFFF;
    }
  }
  @media screen and (max-width: 1024px) {
    width: 100%;
    ul {
      overflow: scroll;
      display: flex;
    }
    li {
      flex: 1 0 auto;
      padding: 0px 10px;
      a {
        font-size: 16px;
      }
    }
  }
`;


const liData = [
  {
    to: "/story/#episode0",
    text: "歷史沿革"
  },
  {
   to: "/story/#episode1",
    text: "#品牌故事01"
  },
  {
   to: "/story/#episode2",
    text: "#02"
  },
  {
   to: "/story/#episode3",
    text: "#03"
  },
  {
   to: "/story/#episode4",
    text: "#04"
  },
  {
   to: "/story/#episode5",
    text: "#05"
  },
  {
   to: "/story/#episode6",
    text: "#06"
  },
  {
    to: "/story/#episode7",
     text: "#07"
   }
]

const Bar = () => {
  const scrollEl = useRef();
  const [scrollToggle, setScrollToggle] = useState({
    l: false,
    r: true
  })

  const scrollOffset = el => {
    setTimeout(() => {
      window.scrollTo({
        top: el.offsetTop - 50,
        behavior: "smooth"
      });
    }, 500);
  };

  const handleScroll = () => {
    const el = scrollEl.current;
    if(el.scrollLeft + el.clientWidth >= el.scrollWidth) {
      return setScrollToggle({
        l: true,
        r: false
      });
    }
    if(el.scrollLeft <= 0) {
      return setScrollToggle({
        l: false,
        r: true
      });
    }
    if(0 < el.scrollLeft + el.clientWidth && el.scrollWidth > el.scrollLeft + el.clientWidth) {
      return setScrollToggle({
        l: true,
        r: true
      });
    }
    // console.log(el.scrollLeft, el.scrollWidth, el.clientWidth)
    // console.log(scrollEl.current.clientWidth)
  }

  return (
    <BarContainer>
      <Box opacityState={scrollToggle}>
        <ul ref={scrollEl} onScroll={handleScroll}>
          {liData.map((items, keys) => {
            const {to, text} = items;
            return (
              <li key={keys}>
                <NavLink
                  smooth
                  to={to}
                  scroll={el => {
                    scrollOffset(el)
                  }}
                >
                  {text}
                </NavLink>
              </li>
            )
          })}
        </ul>
      </Box>
    </BarContainer>
  )
};

export default Bar;